/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { RoleBase } from './role-base';
import { SapCustomer1 } from './sap-customer1';
import { SapCustomer2 } from './sap-customer2';
import { Vendor1 } from './vendor1';

/**
 * 
 * @export
 * @interface ProfileManagement
 */
export interface ProfileManagement {
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    clientId?: string;
    /**
     * 
     * @type {SapCustomer1}
     * @memberof ProfileManagement
     */
    sapCustomer?: SapCustomer1;
    /**
     * 
     * @type {Array<SapCustomer2>}
     * @memberof ProfileManagement
     */
    enabledSapCustomers?: Array<SapCustomer2>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileManagement
     */
    enabledSapCustomerNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    sapId?: string;
    /**
     * 
     * @type {Array<RoleBase>}
     * @memberof ProfileManagement
     */
    roles?: Array<RoleBase>;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileManagement
     */
    isImpersonated?: boolean;
    /**
     * 
     * @type {object | Vendor1}
     * @memberof ProfileManagement
     */
    vendor?: object | Vendor1;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileManagement
     */
    associatedProductTypes?: Array<ProfileManagementAssociatedProductTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    deletedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    functionTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    locale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileManagement
     */
    group?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ProfileManagementAssociatedProductTypesEnum {
    Batter = 'Batter',
    Foil = 'Foil',
    Boxes = 'Boxes',
    Pallets = 'Pallets',
    AmbientFinished = 'Ambient_Finished',
    FrozenFinished = 'Frozen_Finished',
    FrozenBulk = 'Frozen_Bulk',
    Oil = 'Oil',
    Salt = 'Salt',
    IngredientsOther = 'Ingredients_Other',
    Transport = 'Transport'
}



